<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Cargos</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
                            {
                                text: 'Homepage',
                                disabled: false,
                                to: '/home',
                                exact: true,
                            },
                            {
                                text: 'Cargos',
                                disabled: true,
                                exact: true,
                            },
                        ]"></v-breadcrumbs>
                    </div>
                    <div class="button-group" style="padding-right: 16px;">
                        <v-btn v-if="$check(user, ['roles.create'])"
                        id="btnNew" type="button" color="primary" elevation="0" to="/cargos/novo">Incluir</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>
        <!--<v-row>
            <v-col cols="12">
                <v-card class="filter-card">
                    <v-card-title class="filter-card-title">Filtro</v-card-title>
                    <v-card-text>
                        <v-form @submit.prevent="load()">
                            <v-row>
                                <v-col cols="12" sm="12">
                                    <v-text-field dense label="Nome" v-model="dataList.filter.name" hide-details
                                        outlined></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-btn id="btnFilter" type="submit" color="primary" dark
                                        elevation="2">Filtrar</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>-->
        <!-- <template>
            <v-row>
                <v-col cols="12" sm="4">
                    <CardItemA color="red" icon="mdi-account-details-outline" title="CARGO ADMIN A"
                        description="Total de usuários com este cargo" value="N/A" />
                </v-col>
                <v-col cols="12" sm="4">
                    <CardItemA color="red" icon="mdi-account-details-outline" title="CARGO ADMIN B"
                        description="Total de usuários com este cargo" value="N/A" />
                </v-col>
                <v-col cols="12" sm="4">
                    <CardItemA icon="mdi-account-details-outline" title="CARGO C"
                        description="Total de usuários com este cargo" value="N/A" />
                </v-col>
                <v-col cols="12" sm="4">
                    <CardItemA icon="mdi-account-details-outline" title="CARGO D"
                        description="Total de usuários com este cargo" value="N/A" />
                </v-col>
                <v-col cols="12" sm="4">
                    <CardItemA icon="mdi-account-details-outline" title="CARGO E"
                        description="Total de usuários com este cargo" value="N/A" />
                </v-col>
                <v-col cols="12" sm="4">
                    <CardItemA icon="mdi-account-details-outline" title="CARGO F"
                        description="Total de usuários com este cargo" value="N/A" />
                </v-col>
            </v-row>
        </template> -->

        <v-row>
            <v-col cols="12">
                <v-card class="table-card">
                    <v-card-title class="filter-card-title">Filtros</v-card-title>
                    <v-form @submit.prevent="load()">
                        <v-divider class="mt-2"></v-divider>

                        <v-container>
                            <v-row class="mt-3">
                                <v-col cols="4" align-self="baseline">
                                    <v-text-field style="padding-left: 8px;" dense label="Procurar"
                                        v-model="dataList.filter.content" no-data-text="Nenhuma informação disponível" 
                                        hide-details outlined clearable @click:clear="clearNameSearch">
                                    </v-text-field>
                                </v-col>

                                <v-spacer></v-spacer>

                                <v-col v-if="hasFilters()" cols="auto" style="padding-right: 1px;">
                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-btn v-on="on" id="btnClearFilter" type="button" outlined color="primary"
                                                @click="clearFilters">
                                                Limpar</v-btn>
                                        </template>
                                        <span>Limpar filtros de busca selecionados</span>
                                    </v-tooltip>
                                </v-col>

                                <v-col cols="auto" style="padding-right: 16px;">
                                    <v-btn id="btnFilter" type="submit" color="primary" dark
                                        elevation="2">Filtrar</v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>

                    <v-card-title class="table-card-title">Cargos</v-card-title>
                    <v-card-text>
                        <v-data-table :headers="dataList.headers" :items="dataList.data"
                            :server-items-length="dataList.count" @update:items-per-page="pageSizeChanged"
                            @update:page="pageChanged" :disable-sort="true" :loading="dataList.loading"
                            no-data-text="Nenhum usuário foi encontrado" loading-text="Carregando dados..."
                            class="app-table hover-table" :options.sync="dataList.options"
                            :footer-props="dataList.footerOptions">
                            <template v-slot:[`item.name`]="{ item }">
                                <v-avatar :size="30">
                                    <img :src="'https://ui-avatars.com/api/?name=' + item.name" />
                                </v-avatar>
                                <span class="ml-4 list-item-title">{{ item.name }}</span><br />
                            </template>

                            <template v-slot:[`item.status`]="{ item }">
                                <v-chip :color="item.status == 0 ? 'accent' : 'error'" label text-color="white">
                                    {{ item.status | enum(dataset.status, "id", "name") }}
                                </v-chip>
                            </template>

                            <template v-slot:[`item.account_verified_at`]="{ item }">
                                <v-chip
                                    :color="item.account_verified_at !== '0000-00-00 00:00:00' ? 'accent' : 'warning'"
                                    label text-color="white">
                                    {{ item.account_verified_at !== '0000-00-00 00:00:00' ? 'SIM' : 'NÃO' }}
                                </v-chip>
                            </template>

                            <template v-slot:[`item.created_at`]="{ item }">
                                {{ item.created_at | defaultDate("DD/MM/YYYY HH:mm:ss") }}
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                                <v-icon v-if="!$check(user, ['roles.update'])"
                                    :disabled="!$check(user, ['roles.find'])"
                                    @click="viewItem(item)" size="large" class="me-2">
                                    mdi-eye-outline
                                </v-icon>
                                <v-icon :disabled="(!$check(user, ['roles.update']))"
                                    @click="viewItem(item)" size="large"
                                    class="me-2">
                                    mdi-pencil-outline
                                </v-icon>
                                <v-icon :disabled="(!$check(user, ['roles.delete']))"
                                    @click="deleteItem(item)"
                                    size="large" class="me-2">
                                    mdi-delete
                                </v-icon>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';

import object from "@/common/util/object"
import status from "@/common/data/user-status.data";
import userTypes from "@/common/data/user-types.data";

// import CardItemA from "@/layouts/components/CardItemA";

Vue.use(VueLodash)

export default {
    name: "UserList",

    // components: {
    //     CardItemA,
    // },

    data: () => ({
        user: null,
        dataset: {
            status: [{ id: "", name: "Todos" }, ...status],
            userTypes: userTypes,
            clients: [],
            units: [],
            data: {}
        },
        dataList: {
            filter: {
                content: "",
            },
            headers: [
                { text: "Nome", value: "name" },
                { text: "Criado em", value: "created_at" },
                { text: 'Ações', value: 'actions', sortable: false },
            ],
            data: [],
            loading: false,
            count: 0,
            options: {
                page: 1,
                itemsPerPage: 10,
                sortBy: ['name'],
                sortDesc: [false],
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [10, 20, 30, 40, 50],
                pageText: '{0}-{1} de {2}',
            }
        },
    }),

    created() {
        this.load();
    },

    methods: {
        pageChanged(page) {
            this.dataList.options.page = page;
            this.load();
        },

        pageSizeChanged(size) {
            this.dataList.options.itemsPerPage = size;
            this.load(true);
        },

        goBack() {
            this.$router.replace("/cargos");
        },

        hasFilters() {
            return Object.values(this.dataList.filter).some(value => value !== "");
        },

        clearFilters() {
            Object.keys(this.dataList.filter).forEach(key => {
                this.dataList.filter[key] = "";
            });
            this.load();
        },

        clearNameSearch() {
            this.dataList.filter.content = "";
            this.load();
        },

        debounce: _.debounce(function () {
            this.reload();
        }, 500),

        reload: function () {
            this.load();
        },

        async load() {
            this.user = this.$root.user.data || this.$root.user;

            let search = Object.fromEntries(Object.entries(this.dataList.filter).filter(([_, v]) => v))

            search = !object.isEmpty(search) ? search : null;

            this.dataList.loading = true;

            var limit = this.dataList.options.itemsPerPage;

            try {
                const result = await axios.get('/api/role/list', { params: { page: this.dataList.options.page, limit: limit, search: search } });

                this.dataList.data = result.data.content.data;
                this.dataList.count = result.data.content.paging.total;

            } catch (error) {
                console.log('error ', error)
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }

        },

        async deleteItem(item) {
            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja realmente deletar este cargo? Esta ação não pode ser desfeita.',
                title: 'Deletar cargo',
                actions: {
                    false: 'Cancelar',
                    true: 'Deletar',
                },
            });

            if (!proceedAction) return;

            try {
                //console.log("id:", item.id)
                const response = await axios.delete(`/api/role/delete/${item.id}`);

                this.$dialog.notify.info(response.data.message || 'Cargo deletado com sucesso!', {
                    position: 'top-right',
                    timeout: 2000,
                });

                this.$router.go(0);
            } catch (error) {
                this.$dialog.notify.error('Erro ao deletar o cargo.', {
                    position: 'top-right',
                    timeout: 2000,
                });
            }
        },

        viewItem(item) {
            this.$router.push(`cargos/${item.id}`);
        },
    },
};
</script>